class DetailsModal extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");

    this.detailsContainer.addEventListener("keyup", (event) => event.code.toUpperCase() === "ESCAPE" && this.close());
    this.summaryToggle.addEventListener("click", this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]')?.addEventListener("click", this.close.bind(this));

    this.summaryToggle.setAttribute("role", "button");
  }

  connectedCallback() {
    this.init();
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest("details").hasAttribute("open") ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay")) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest("details").setAttribute("open", true);
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");
    
    if (this.classList.contains("size-chart-modal")) {
      const pdpSticky = document.querySelector("product-info.product__column-sticky");
      if(pdpSticky) pdpSticky.style.position = "static";
    }

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])') || this.detailsContainer.querySelector('.modal__close-button')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");

    if (this.classList.contains("size-chart-modal")) {
      const pdpSticky = document.querySelector("product-info.product__column-sticky");
      if(pdpSticky) pdpSticky.style.position = "sticky";
    }

    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("details-modal", DetailsModal);
